export interface WeeklyAttendanceDay {
  day: string;
  date: string;
  present: number;
  absent: number;
  total: number;
}

function generateDayStr(daysAgo: number): string {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return d.toISOString().split('T')[0];
}

const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

function getDayName(daysAgo: number): string {
  const d = new Date();
  d.setDate(d.getDate() - daysAgo);
  return dayNames[d.getDay()];
}

export const weeklyAttendance: WeeklyAttendanceDay[] = [
  { day: getDayName(6), date: generateDayStr(6), present: 10, absent: 2, total: 12 },
  { day: getDayName(5), date: generateDayStr(5), present: 11, absent: 1, total: 12 },
  { day: getDayName(4), date: generateDayStr(4), present: 9,  absent: 3, total: 12 },
  { day: getDayName(3), date: generateDayStr(3), present: 12, absent: 0, total: 12 },
  { day: getDayName(2), date: generateDayStr(2), present: 10, absent: 2, total: 12 },
  { day: getDayName(1), date: generateDayStr(1), present: 11, absent: 1, total: 12 },
  { day: getDayName(0), date: generateDayStr(0), present: 10, absent: 2, total: 12 },
];